<template>
  <!-- Mirrors the shared range control in AnalyticsPage.vue class for class, so
       the Tasks header is indistinguishable from the Bookings and Traffic ones.
       It drives useTaskStatsStore rather than useAnalyticsStore, which is the
       only reason it is a separate component. -->
  <div class="flex items-center gap-2 flex-shrink-0">
    <button type="button" @click="refresh" :disabled="store.loading" title="Refresh"
      class="w-8 h-8 flex items-center justify-center rounded-lg text-gray-400 dark:text-gray-500 hover:text-gray-600 dark:hover:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors disabled:opacity-40">
      <svg class="w-4 h-4" :class="store.loading ? 'animate-spin' : ''" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
        <path stroke-linecap="round" stroke-linejoin="round" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"/>
      </svg>
    </button>

    <!-- Segmented on desktop, a select on mobile: five pills do not fit on a
         phone alongside the title without becoming unhittable. -->
    <div class="hidden md:flex items-center gap-0.5 bg-gray-100 dark:bg-gray-800 rounded-lg p-1">
      <button v-for="option in TASK_STAT_RANGES" :key="option.value" type="button"
        @click="store.setFilters({ range: option.value })"
        class="px-2.5 py-1 text-xs font-semibold rounded-md transition-all"
        :class="store.filters.range === option.value
          ? 'bg-white dark:bg-gray-700 text-gray-900 dark:text-white shadow-sm'
          : 'text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200'">
        {{ option.label }}
      </button>
    </div>
    <select :value="store.filters.range" @change="store.setFilters({ range: $event.target.value })"
      class="md:hidden text-xs font-semibold text-gray-600 dark:text-gray-300 bg-gray-100 dark:bg-gray-800 border-0 rounded-lg px-2.5 py-1.5 focus:ring-2 focus:ring-blue-500 outline-none">
      <option v-for="option in TASK_STAT_RANGES" :key="option.value" :value="option.value">{{ option.long }}</option>
    </select>
  </div>
</template>

<script setup>
import { useTaskStatsStore } from 'stores/taskStats.js'
import { TASK_STAT_RANGES } from './statsRanges.js'

const store = useTaskStatsStore()

async function refresh() {
  store.invalidate()
  await store.fetchStats()
}
</script>
